import { gsap } from "gsap";
import { Locomo } from "./../_scroll/locomo";

export const StoreDrawer = {
  /**
   * funcs
   */
  init: function() {
    StoreDrawer.drawer()
  },
  drawer:function(){
    document.querySelectorAll(".l-store .list .item .store-trigger,.l-faq .list .item .faq-trigger").forEach(function(item){
      item.addEventListener('click', function(){
        item.closest(".item").classList.toggle('is-active');
        let detail=item.nextElementSibling;
        if(this.closest(".item").classList.contains('is-active')){
          gsap.set(detail, {height:"auto"})
          gsap.from(detail, {height:0, duration: 0.6,onComplete:()=>{
            Locomo.update()
          }})
        }
        else{
          gsap.to(detail, {height:0, duration: 0.5,onComplete:()=>{
            Locomo.update()
          }})
        }
      })
    })
  }
};
